import Swiper, { Navigation } from 'swiper'
import { assign } from 'lodash';
import { nodeListToArray } from '../helpers/nodeListToArray';
import { sendVisibleCarouselItemsListScriptToGTM } from './shop-google-analytics';


export interface ICarousel {
    width?: number;
    containerClass: string;
    slidesPerView?: number;
    centeredSlides?: boolean;
    breakpoints?: any;
    spaceBetween?: number;
    navigation?: any;
    autoHeight?: boolean;
    height?: number;
    loop?: boolean;
    autoplayVideo?: boolean;
    pageNumberPreposition?: string;
    watchSlidesVisibility?: boolean;
}
interface IPersonalizedProductData {
    authors: IAuthor[];
    itemNumber: string;
    itemName: string;
    newUntilDate: string;
    itemPublicationDate: string;
    startDate: string;
    endDate: string;
    bestseller: boolean;
    itemMemberPrice: number;
    itemRetailPrice: number;
    pricesLoading: boolean;
    isMemberBenefit: boolean;
    format: string;
    url: string;
    productImage: string;
    fullLocation: string;
    state: string;
    tags: string[];
    showAvailabilityDates: boolean;
    showPublicationDate: boolean;
    shortDescription: string;
    externalRegistrationUrl: string;
    category: string;
    isQuantityDiscount: boolean;
    healthyChildrenProduct: boolean;
    relevance: number;
    isMember: boolean;
    customFilterValues: string[];
    topics: string[];
    topicNames: string[];
    productType: ProductType;
    data: any;
}

interface IAuthor {
    authorName: string;
    authorBio: string;
    authorOfRole: string;
    authorOfDescription: string;
}

interface IPersonalizedProducts {
    alias: string;
    position: string;
    recs: IPersonalizedProduct[];
    widget: string;
}

interface IPersonalizedProduct {
    id: number;
    img: string;
    refCode: string;
    title: string;
    url: URL;
    prices: IPriceType[];
}

interface IPriceType {
    USD: IPrice;
}

interface IPrice {
    salePrice: number;
    unitPrice: number;
}

enum ProductType {
    BOOK,
    EBOOK,
    JOURNAL,
    LIVE_ACTIVITY,
    COURSE,
    BROCHURE,
    POINT_OF_CARE,
    DEFAULT
}

var impressedItems = [];


declare global {
    interface Window {
        InitPeeriusCarousel: (data: any) => void }
}
window.InitPeeriusCarousel = function (data) {
    const carouselClass = 'peerius-carousel';
    const personalizedCarousels = nodeListToArray(document.querySelectorAll('[data-product-carousel-personalized]'));
    personalizedCarousels.forEach((carousel, index) => {
        carousel.classList.add(`${carouselClass}-${index}`);
        renderCarousel(data[0], `${carouselClass}-${index}`);
    });
}

export function renderCarousel(data: any, carouselClass) {
    initImpressions();
    var count = 0;
    var carouselData = data;
    var promiseCount = 0;
    if (carouselData == undefined || carouselData.recs == undefined) {
        return;
    }
    const swiperElement = document.querySelector(`.${carouselClass}`).querySelector('.swiper-wrapper');
    carouselData.recs.forEach(rec => {
        getProductData(rec.refCode, count, rec.id, swiperElement).then(res => {
            promiseCount++;
            if (promiseCount === carouselData.recs.length) {
                //initialize the carousel once we have all the items and they are appended to the block
                new ProductCarousel({
                    containerClass: `${carouselClass}`,
                    slidesPerView: 1
                })
                sendImpressions();
            }
        });
        count++;
    });
}
//takes a single peerius recommended content item and gets the corresponding item from the search api
function getProductData(refCode: string, index: number, id: number, swiperElement: Element) {
    const init: RequestInit = {
        method: 'GET',
        credentials: 'same-origin'
    };

    return window.fetch(`/api/v1/search/getProduct?refCode=${refCode}`, init)
        .then(res => {
            if (res.status !== 200) {
                throw new Error(res.statusText);
            }
            return res.text().then(data => {
                renderCarouselProductItem(data as any, index, id, swiperElement);
            });
        });
}
//takes the data we got in the search api call and adds wrapper with items for the result
function renderCarouselProductItem(productData: any, index: number, id: number, swiperElement) {
    var parsedData = JSON.parse(productData) as IPersonalizedProductData;

    var productSwiperWrap = document.createElement('div');
    productSwiperWrap.setAttribute('class', 'swiper-slide');
    productSwiperWrap.setAttribute('slide-number', index.toString());
    productSwiperWrap.innerHTML = `
        <div class="data-wrapper">
            <div class="carousel-image" carousel-image><a class="carousel-link" carousel-link-js href=""><img class="carousel-image" carousel-image-js src=""></a></div>
            <div class="medium"><ul class="unlisted"><li class="tag-carousel" tag-carousel-js></li></ul></div>
            <div class="title-click" title-click-js><a class="carousel-title" carousel-title-js href="#"></a></div>
            <div class="publish-dates">
               <p class="publish-date" pub-date-js></p>
            </div>
            <div class="retail-price">
                <span class="priceLabel">Price:</span>
                <span class="price cash" retail-cash-js></span>
            </div>
            <div class="member-price">
		        <span class="priceLabel">Member Price:</span>
                <span  class="price cash" member-cash-js></span>
            </div>
            <div style="display: none" class="id-carousel-js" id-carousel-js"></div>
        </div>
    `;
    
    var personalizedCarousel = productSwiperWrap;
    swiperElement.append(personalizedCarousel);
    if (personalizedCarousel != undefined && parsedData != null && parsedData.data != null) {
        fillInData(personalizedCarousel, parsedData, index, id, swiperElement);
        addDataAttributesForGoogleAnalytics(productSwiperWrap, parsedData);
    }

}

function addDataAttributesForGoogleAnalytics(productSwiperWrap: HTMLDivElement, jsonData: IPersonalizedProductData) {
    //Add data attributes to carousel item for Google Analytics tracking.
    productSwiperWrap.dataset.productCarouselItemTitle = jsonData.data.itemName;
    productSwiperWrap.dataset.productCarouselItemId = jsonData.data.itemNumber;
    productSwiperWrap.dataset.productCarouselItemPrice = jsonData.data.itemRetailPrice;
    productSwiperWrap.dataset.productCarouselItemCategory = jsonData.data.topicNames && jsonData.data.topicNames.length > 0 ?
        jsonData.data.topicNames.join(" ") : "";
}

// fills in the carousel item with data. Could be condensed into the template literal above when using for multiple types of carousels
function fillInData(personalizedCarousel: Element, jsonData: IPersonalizedProductData, index: number, id: number, carouselClass: string) {
    let parsedData = jsonData.data;
    personalizedCarousel.querySelector('[retail-cash-js]').textContent = parsedData.itemRetailPrice != null ? ("$" + parsedData.itemRetailPrice.toFixed(2).toString()) : "$0.00";
    personalizedCarousel.querySelector('[member-cash-js]').textContent = parsedData.itemMemberPrice != null ? ("$" + parsedData.itemMemberPrice.toFixed(2).toString()) : "$0.00";
    personalizedCarousel.querySelector('[carousel-title-js]').textContent = parsedData.itemName;
    personalizedCarousel.querySelector('[carousel-title-js]').setAttribute("href", parsedData.url);
    personalizedCarousel.querySelector('[tag-carousel-js]').textContent = parsedData.tags[0];

    if (personalizedCarousel.querySelector('[id-carousel-js]') != null &&
        personalizedCarousel.querySelector('[id-carousel-js]') != undefined) {
        personalizedCarousel.querySelector('[id-carousel-js]').textContent = id.toString();
    }
    fillInPublishedDate(personalizedCarousel, parsedData.itemPublicationDate);
    fillInImage(personalizedCarousel, parsedData);
    markClicks(personalizedCarousel, parsedData);
}

function fillInPublishedDate(personalizedCarousel: Element, publishedDate: string) {
    if (publishedDate.substr(0, 4) !== "0001") {
        personalizedCarousel.querySelector('[pub-date-js]').textContent = "Published: " + publishedDate.substr(0, 4);
    }
}

function fillInImage(personalizedCarousel: Element, parsedData: IPersonalizedProductData) {
    var image = personalizedCarousel.querySelector('[carousel-image]').querySelector('[carousel-image-js]');
    var link = personalizedCarousel.querySelector('[carousel-image]').querySelector('[carousel-link-js]');
    image.setAttribute("src", parsedData.productImage);
    link.setAttribute("href", parsedData.url);
}


function markClicks(personalizedCarousel: Element, parsedData: IPersonalizedProductData) {
    personalizedCarousel.querySelector('[carousel-image-js]').addEventListener("click",
        (event) => {
            clickToPage(personalizedCarousel);
            pushViewItemInListEventToGoogleTagManager(personalizedCarousel, parsedData);
            event.stopImmediatePropagation();
        });
    personalizedCarousel.querySelector("[carousel-title-js]").addEventListener("click",
        (event) => {
            clickToPage(personalizedCarousel);
            pushViewItemInListEventToGoogleTagManager(personalizedCarousel, parsedData);
            event.stopImmediatePropagation();
        });
    personalizedCarousel.addEventListener("click",
        () => {
            otherClick(personalizedCarousel);
        });
}

function clickToPage(personalizedCarousel: Element) {
    console.log("clickedToPage");
    var id = personalizedCarousel.querySelector('[id-carousel-js]');
    if (id) {
        (window as any).Peerius.smartRecsClick(personalizedCarousel.querySelector('[id-carousel-js]').textContent);
    }
}

function otherClick(personalizedCarousel: Element) {
    console.log("clickedOther");
    (window as any).Peerius.smartRecsSendClick(personalizedCarousel.querySelector('[id-carousel-js]').textContent);
}

function pushViewItemInListEventToGoogleTagManager(personalizedCarousel: Element, parsedData: IPersonalizedProductData) {

    //Send Google Tag Manager event any time a user clicks an item in a carousel.

    //Google wants to know which carousel the item was within, so we pull the carousel ID and carousel name.
    var id = "";
    var listTitle = "";
    var carouselContainer = document.querySelector('[data-product-carousel-personalized]');
    if (carouselContainer) {
        id = carouselContainer.getAttribute('data-unique-id');
        const carouselTitle = carouselContainer.querySelector('[data-product-carousel-title]');
        if (carouselTitle) {
            listTitle = (carouselTitle as HTMLElement).innerText;
        }
    }

    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.

    //Google also wants to know information about the specific catalog item in the carousel that the user chose.
    var tag = {
        'event': 'select_item',
        'ecommerce':
        {
            'item_list_id': id,
            'item_list_name': listTitle,
            'items': [
                {
                    'item_id': parsedData.itemNumber,
                    'item_name': parsedData.itemName,
                    'price': parsedData.itemRetailPrice,
                    'item_category': parsedData.topicNames.join(" ")
                }
            ]
        }
    };

    console.log(`Sending tag to data layer: ${JSON.stringify(tag)}`);
    (window as any).dataLayer.push(tag);
}


function initImpressions() {
    if (document.querySelector('[data-product-carousel]') != null &&
        document.querySelector('[data-product-carousel]') != undefined) {
        document.querySelector('[data-product-carousel]').addEventListener("click", sendImpressions);
    }
}

function sendImpressions() {
    var carousel = document.querySelector('[data-product-carousel]');
    if (carousel === undefined || carousel === null) {
        return;
    }
    var swiperElement : any = carousel.querySelector('.swiper-wrapper');
    var swiperVisibleItems = swiperElement.querySelectorAll('.swiper-slide-visible');
    if (swiperVisibleItems != null && swiperElement.swiper != null) {
        var seenIds = [];
        for (var i = 0; i < swiperVisibleItems.length; i++) {
            var visibleItem = swiperVisibleItems[i];
            var id = visibleItem.querySelector('[id-carousel-js]').textContent;
            seenIds.push(id);
        }
        sendImpressionIds(seenIds);
    }
}


function sendImpressionIds(seenIds: Array<number>) {
    var strIds = "";
    for (var i = 0; i < seenIds.length; i++) {
        if (impressedItems.indexOf(seenIds[i]) > -1) {
            continue;
        }
        else if (strIds.length === 0) {
            strIds = seenIds[i].toString();
            impressedItems.push(seenIds[i]);
        } else if (seenIds[i] != null && seenIds[i].toString().length > 0) {
            strIds = strIds + "," + seenIds[i];
            impressedItems.push(seenIds[i]);
        }
    }
    if (strIds.length > 0) {
        (window as any).Peerius.sendAjax(`aap/rec/shown.pagex?ids=${strIds}`);
    }
}

export class ProductCarousel {
    //these params are exposed to the file you intialize your carousel in, so you can initialize multiple
    //carousel versions across your project or just be able to configure without diving into this file
    params: ICarousel = {
        containerClass: 'adage-carousel-js',
        centeredSlides: false,
        slidesPerView: 1,
        watchSlidesVisibility: true,
        breakpoints: {
            320: {
                spaceBetween: 16,
                slidesPerView: 2
            },
            640: {
                spaceBetween: 33,
                slidesPerView: 3
            },
            800: {
                spaceBetween: 33,
                slidesPerView: 4
            },
            1400: {
                spaceBetween: 33,
                slidesPerView: 5
            },
            1920: {
                spaceBetween: 33,
                slidesPerView: 6
            }
        },
        spaceBetween: 25,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        loop: false,
        autoplayVideo: true,
        pageNumberPreposition: ' of ',
        autoHeight: true
    };
    productCarousel: any;
    activeSlide: any;
    previousSlide: any;
    activeIndex: any;
    previousIndex: number; // swiper's previousindex implementation doesn't work with loop: true so we need to do it manually
    videos: any;
    carouselId: string;
    productData: any;

    constructor(params?: ICarousel) {

        assign(this.params, params);
        Swiper.use([Navigation]);
        this.productCarousel = new Swiper(`.${this.params.containerClass}`, {
            slidesPerView: this.params.slidesPerView,
            centeredSlides: this.params.centeredSlides,
            spaceBetween: this.params.spaceBetween,
            breakpoints: this.params.breakpoints,
            navigation: this.params.navigation,
            watchSlidesVisibility: true,
            
            loop: this.params.loop,
            on: {
                afterInit: this.sendVisibleItemsToGoogleTagManager.bind(this),
                slideChange: this.sendVisibleItemsToGoogleTagManager.bind(this)
            },
            enabled: true,
            autoHeight: this.params.autoHeight
        });
        if (this.productCarousel.el) {
            this.carouselId = this.productCarousel.el.getAttribute('data-unique-id');
        }
        this.videos = {};
        this.initCallback();
        setTimeout(() => this.productCarousel.resize.resizeHandler(), 2000); // SUPER hack... but it works
    }

    initCallback() {
        this.activeSlide = this.productCarousel.slides[this.productCarousel.activeIndex];
        this.activeIndex = this.productCarousel.activeIndex;
        this.setPageNumbers();
    }

    setPageNumbers() {
        if (this.productCarousel) {
            let totalSlides = this.productCarousel.el.getAttribute('data-total-slides');
            for (let i = 0; i < this.productCarousel.slides.length; i++) {
                let slide = this.productCarousel.slides[i];
                this.reconcileDupeId(slide);
                if (i !== this.activeIndex) {
                    this.disableSlide(slide);
                }
                let slidePageContainer = slide.querySelector('[data-carousel-page]');
                if (slidePageContainer) {
                    let pageString = `${parseInt(slide.getAttribute('data-slide-index')) + 1}${this.params.pageNumberPreposition}${totalSlides}`;
                    slidePageContainer.innerHTML = pageString;
                }
            }

        }
    }

    reconcileDupeId(slide) {
        // check to see if there's 2 slides with same unique ID (when loop is true, slides get duplicated)
        if (slide.querySelector('[data-unique-id]')) {
            let thisId = slide.querySelector('[data-unique-id]').getAttribute('data-unique-id');
            if (this.productCarousel.el.querySelectorAll(`[data-unique-id="${thisId}"]`).length > 1) {
                let dupes = Array.prototype.slice.call(this.productCarousel.el.querySelectorAll(`[data-unique-id="${thisId}"]`));
                dupes.forEach((dupe, index) => {
                    dupe.setAttribute('data-unique-id', `${thisId}-${index}`);
                })
            }
        }
    }

    handleSlide() {
        if (this.productCarousel) {
            this.previousSlide = this.activeSlide;
            this.previousIndex = this.activeIndex;
            this.activeSlide = this.productCarousel.slides[this.productCarousel.activeIndex];
            this.activeIndex = this.productCarousel.activeIndex;
            this.disableSlide(this.previousSlide);
            this.enableSlide(this.activeSlide);
        }
    }

    disableSlide(slide) {
        // disable tabbing on tabbable content by default to stop trapping keyboard, and hide from screenreader users
        let tabbableContent = Array.prototype.slice.call(slide.querySelectorAll('a, input, button, area, object, select, iframe, video, audio'));
        tabbableContent.forEach(item => {
            item.tabIndex = -1;
        });
        slide.setAttribute('aria-hidden', 'true');
    }

    enableSlide(slide) {
        // enable tabbing on active slide and show to screenreader users
        let tabbableContent = Array.prototype.slice.call(slide.querySelectorAll('a, input, button, area, object, select, iframe, video, audio'));
        tabbableContent.forEach(item => {
            item.tabIndex = 0;
        });
        slide.setAttribute('aria-hidden', 'false');
    }

    sendVisibleItemsToGoogleTagManager() {
        const carouselElement = document.querySelector("." + this.params.containerClass);
        sendVisibleCarouselItemsListScriptToGTM(carouselElement);
    }
}